import { Button, Dialog, IconButton, Text, Tooltip } from '@radix-ui/themes';
import { CircleX } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const DeleteAccessGroup = ({
  accessGroup,
  onSubmit,
  loading,
  disable = false,
}: {
  accessGroup: { id: string; name: string };
  onSubmit: (accessGroup: { id: string; name: string }) => Promise<void>;
  loading: boolean;
  disable: boolean;
}) => {
  const { t } = useTranslation();
  const handleSubmit = () => {
    onSubmit(accessGroup).then(() => {});
  };

  return (
    <Dialog.Root>
      <Tooltip
        content={
          <Text size="3">
            {disable
              ? t('settings.accessGroupDialogs.deleteAccessGroup.noPermissionTooltip')
              : t('settings.accessGroupDialogs.deleteAccessGroup.deleteGroupTooltip')}
          </Text>
        }
      >
        <Dialog.Trigger>
          <IconButton variant="ghost" color="gray" highContrast className="m-0" disabled={disable}>
            <CircleX size={20} />
          </IconButton>
        </Dialog.Trigger>
      </Tooltip>
      <Dialog.Content>
        <Dialog.Title>{t('settings.accessGroupDialogs.deleteAccessGroup.dialogTitle')}</Dialog.Title>
        <Dialog.Description>
          {t('settings.accessGroupDialogs.deleteAccessGroup.description', { groupName: accessGroup.name })}
        </Dialog.Description>

        <div className="flex flex-row justify-between w-full pt-2">
          <Dialog.Close>
            <Button size="3" color="gray" variant="soft" className="w-full">
              {t('settings.accessGroupDialogs.deleteAccessGroup.cancelButton')}
            </Button>
          </Dialog.Close>
          <Dialog.Close>
            <Button size="3" color="red" className="w-full" loading={loading} onClick={handleSubmit}>
              {t('settings.accessGroupDialogs.deleteAccessGroup.deleteButton')}
            </Button>
          </Dialog.Close>
        </div>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default DeleteAccessGroup;
